/* Zolo Home — homepage interactivity (spotlight buy box, FAQ tabs) */
(function () {
  if (window.__zhomeJSLoaded) return;
  window.__zhomeJSLoaded = true;

  function initSpotlight(root) {
    if (root.dataset.zspotInit) return;
    root.dataset.zspotInit = '1';

    var priceEl = root.querySelector('[data-zspot-price]');
    var compareEl = root.querySelector('[data-zspot-compare]');
    var saveEl = root.querySelector('[data-zspot-save]');
    var idInput = root.querySelector('input[name="id"]');
    var atc = root.querySelector('[data-zspot-atc]');
    var varsEl = root.querySelector('[data-zspot-variants]');
    var prefixEl = root.querySelector('[data-zspot-prefix]');
    var variants = [];
    try { variants = JSON.parse(varsEl ? varsEl.textContent : '[]'); } catch (e) { variants = []; }
    var prefix = prefixEl ? prefixEl.textContent.trim() : 'AED';

    function fmt(cents) {
      return prefix + ' ' + (cents / 100).toFixed(2);
    }

    root.querySelectorAll('input[name="zspot-option"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === String(radio.value); });
        if (!v || !idInput) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          compareEl.textContent = onSale ? fmt(v.compare_at_price) : '';
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          saveEl.textContent = onSale ? (saveEl.dataset.label || 'Save') + ' ' + fmt(v.compare_at_price - v.price) : '';
        }
        if (atc) {
          var soldout = root.querySelector('[data-zspot-soldout]');
          var add = root.querySelector('[data-zspot-add]');
          atc.disabled = !v.available;
          atc.textContent = v.available ? (add ? add.textContent : 'Add to Cart') : (soldout ? soldout.textContent : 'Sold Out');
        }
      });
    });

    var qty = root.querySelector('[data-zspot-qty]');
    root.querySelectorAll('[data-zspot-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        var next = (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.zspotQtyChange, 10);
        qty.value = Math.max(1, next);
      });
    });
  }

  function initFaq2(root) {
    if (root.dataset.zfaq2Init) return;
    root.dataset.zfaq2Init = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-zfaq2-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-zfaq2-item]'));

    function setOpen(item, open) {
      var q = item.querySelector('.zhome-faq2__q');
      var a = item.querySelector('.zhome-faq2__a');
      item.classList.toggle('is-open', open);
      if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (a) a.hidden = !open;
    }

    function activate(cat) {
      tabs.forEach(function (t) {
        var on = t.dataset.zfaq2Tab === cat;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var first = true;
      items.forEach(function (item) {
        var show = item.dataset.cat === cat;
        item.hidden = !show;
        setOpen(item, show && first);
        if (show) first = false;
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.dataset.zfaq2Tab); });
    });

    items.forEach(function (item) {
      var q = item.querySelector('.zhome-faq2__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        items.forEach(function (other) { if (!other.hidden) setOpen(other, false); });
        setOpen(item, willOpen);
      });
    });

    if (tabs.length) activate(tabs[0].dataset.zfaq2Tab);
  }

  function initAll() {
    document.querySelectorAll('[data-zspot]').forEach(initSpotlight);
    document.querySelectorAll('[data-zfaq2]').forEach(initFaq2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-zspot]').forEach(function (r) { delete r.dataset.zspotInit; });
    document.querySelectorAll('[data-zfaq2]').forEach(function (r) { delete r.dataset.zfaq2Init; });
    initAll();
  });
})();
